import { IApiKeyHolder, apiKeyHolder } from "@/utils/apikey";
import { IConfig, config } from "@/utils/config";

export interface Airport {
  name: string;
  iataCode: string;
}

export interface IAirportService {
  search(query: string): Promise<Airport[]>;
}

export class AirportService implements IAirportService {
  public constructor(
    private readonly _config: IConfig,
    private readonly apiKeyHolder: IApiKeyHolder,
  ) {}

  private allAirports: Promise<Airport[]> = null;

  private async loadAllAirlines(): Promise<Airport[]> {
    if (this.allAirports === null) {
      this.allAirports = fetch(
        `${this._config.serviceBaseUrl}/co2footprint/airports`,
        {
          headers: {
            "x-api-key": this.apiKeyHolder.getApiKey(),
          },
        },
      ).then((res) => res.json());
    }
    return this.allAirports;
  }

  public async search(query = ""): Promise<Airport[]> {
    const allAirlines = await this.loadAllAirlines();
    return allAirlines.filter(
      (a) =>
        a.name.toLowerCase().includes(query.toLowerCase()) ||
        a.iataCode.toLowerCase().includes(query.toLowerCase()),
    );
  }
}

export const defaultAirportService = new AirportService(config, apiKeyHolder);
